const GET_QUESTION_OPTIONS = 'GET_QUESTION_OPTIONS';
const SET_QUESTION_OPTIONS = 'SET_QUESTION_OPTIONS';

export
{
    GET_QUESTION_OPTIONS,
    SET_QUESTION_OPTIONS,
};